import type { ProductCardModelProps } from '@/components/shared/product-card/product-card.model'
import { useProductCardModel } from '@/components/shared/product-card/product-card.model'
import { ProductCardView } from '@/components/shared/product-card/product-card.view'

export function ProductCardViewModel(props: ProductCardModelProps) {
  const model = useProductCardModel(props)
  return <ProductCardView {...model} />
}
